import styled from 'styled-components';

import { theme } from '../../global-styles/colors';

export const CardSubsectionStyle = styled.div`
  padding: 16px;
  border-radius: 6px;
  background: ${theme.greys.grey010};

  .MuiFormGroup-root {
    display: flex;
    flex-direction: row;
  }
`;
